import SearchButtons from "components/SearchButtons";
import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import ReactStrapTable from "components/reactStrapTable";
import Checkbox from "components/common/Fields/Checkbox";
import catalogIcon from "../../../../../assets/inventory/catalog.svg";
import addIcon from "../../../../../assets/inventory/add-icon.svg";
import columnSelectorIcon from "../../../../../assets/icon/column-selector.svg";
import deleteIcon from "../../../../../assets/inventory/delete-icon.svg";
import upArrow from "../../../../../assets/inventory/up-arrow.svg";
import downArrow from "../../../../../assets/inventory/down-arrow.svg";
import filterIcon from "../../../../../assets/icon/filter-icon.svg";
import PlusIcon from "../../../../../assets/inventory/plus-icon.svg";
import { toast } from "react-toastify";
import SmartDealModal from "../SmartDealModal";
import greenCheck from "assets/icon/340b-checkIcon.svg";

const CreateManualOrder = () => {
  const [manualRowData, setManualRowData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [tableData, setTableData] = useState(rowData);
  const [data, setData] = useState([]);  const [rSelected, setRSelected] = useState("off");
  
  const handleClick = (row) => {

    setManualRowData([...manualRowData, row]);
  };
  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };
  const headerData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox /> All
        </div>
      ),
      show: true,
      width: 50,
    },
    {
      dataField: "recommended",
      text: "Account",
      show: true,
      sort: true,
      width: 130,
      cellRenderer: (rowData) => (
        <div
          onClick={() => setModalOpen(!modalOpen)}
        
        >
          {rowData.recommended}
        </div>
      ),
    },
    {
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      sort: true,
      width: 120,
        cellRenderer: (rowData) => (
        <div
          onClick={() => setModalOpen(!modalOpen)}
        
        >
          {rowData.manufacturer}
        </div>
      ),
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      sort: true,
      width: 160,
       cellRenderer: (rowData) => (
        <div
          onClick={() => setModalOpen(!modalOpen)}
        
        >
          {rowData.drugname}
        </div>
      ),
    },
    {
      dataField: "ndc",
      text: "NDC",
      show: true,
      sort: true,
       cellRenderer: (rowData) => (
        <div
          onClick={() => setModalOpen(!modalOpen)}
        
        >
          {rowData.ndc}
        </div>
      ),
    },
    {
      dataField: "packagesize",
      text: "Package Size",
      show: true,
      sort: true,
      width: 120,
       cellRenderer: (rowData) => (
        <div
          onClick={() => setModalOpen(!modalOpen)}
        
        >
          {rowData.packagesize}
        </div>
      ),
    },
    {
      dataField: "packageprice",
      text: "Package Price",
      show: true,
      sort: true,
      width: 120,
       cellRenderer: (rowData) => (
        <div
          onClick={() => setModalOpen(!modalOpen)}
        
        >
          {rowData.packageprice}
        </div>
      ),
    },
    {
      dataField: "unitprice",
      text: "Unit price",
      show: true,
      sort: true,
      width: 110,
       cellRenderer: (rowData) => (
        <div
          onClick={() => setModalOpen(!modalOpen)}
        
        >
          {rowData.unitprice}
        </div>
      ),
    },
  ];

  const rowData = [
    {
      id: Date.now(),
      all: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox />{" "}
          <img
            className="cursor-pointer"
            src={addIcon}
            onClick={() => handleClick(allData)}
          />
        </div>
      ),
      recommended: "Mckesson WAC",
      manufacturer: "Sun",
      drugname: "Vaisartan 160 MG Tablet",
      ndc: "672853827",
      packagesize: "100 EA",
      packageprice: "$ 90.27",
      unitprice: "$ 0.9327",
    },
    {
      id: Date.now(),
      all: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox />{" "}
          <img
            className="cursor-pointer"
            src={addIcon}
            onClick={() => handleClick(allData)}
          />
        </div>
      ),
      recommended: "Anda",
      manufacturer: "Teva",
      drugname: "Vaisartan 160 MG Tablet",
      ndc: "672853827",
      packagesize: "100 EA",
      packageprice: "$ 90.27",
      unitprice: "$ 0.9327",
    },
    {
      id: Date.now(),
      all: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox />{" "}
          <img
            className="cursor-pointer"
            src={addIcon}
            onClick={() => handleClick(allData)}
          />
        </div>
      ),
      recommended: (
        <div className="d-flex " style={{ gap: "8px" }}>
          <div>McKesson</div>
          <div className="check-box-green">
            <img src={greenCheck} />
            340B
          </div>
        </div>
      ),
      manufacturer: "Cipla",
      drugname: "Vaisartan 160 MG Tablet",
      ndc: "672853827",
      packagesize: "100 EA",
      packageprice: "$ 90.27",
      unitprice: "$ 0.9327",
    },
    {
      id: Date.now(),
      all: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox />{" "}
          <img
            className="cursor-pointer"
            src={addIcon}
            onClick={() => handleClick(allData)}
          />
        </div>
      ),
      recommended: "Mckesson WAC",
      manufacturer: "Lupin",
      drugname: "Vaisartan 160 MG Tablet",
      ndc: "672853827",
      packagesize: "100 EA",
      packageprice: "$ 90.27",
      unitprice: "$ 0.9327",
    },
    {
      id: Date.now(),
      all: (
        <div className="d-flex justify-content-start align-items-center gap-2">
          <Checkbox />{" "}
          <img
            className="cursor-pointer"
            src={addIcon}
            onClick={() => handleClick(allData)}
          />
        </div>
      ),
      recommended: "BluPax",
      manufacturer: "Aurobindo",
      drugname: "Vaisartan 160 MG Tablet",
      ndc: "34981319898",
      packagesize: "300 EA",
      packageprice: "$ 108.52",
      unitprice: "$ 0.0852",
    },
  ];

  const manualColData = [
    {
      dataField: "all",
      text: (
        <div>
          <Checkbox /> All
        </div>
      ),
      show: true,
    },
    {
      dataField: "option",
      text: "Option",
      show: true,
    },
    {
      dataField: "manufacturer",
      text: "Manufacturer",
      show: true,
      sort: true,
      width: 150,
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      sort: true,
      width: 120,
    },
    {
      dataField: "ndc",
      text: "NDC",
      show: true,
      sort: true,
    },
    {
      dataField: "packagesize",
      text: "Package Size",
      show: true,
      sort: true,
      width: 130,
    },
    {
      dataField: "packageprice",
      text: "Package Price",
      show: true,
      sort: true,
      width: 140,
    },
    {
      dataField: "unitprice",
      text: "Unit Price",
      show: true,
      sort: true,
      width: 120,
    },
    {
      dataField: "requiredqty",
      text: "Required Qty",
      show: true,
      sort: true,
      width: 130,
    },
  ];

  const handleDelete = (id) => {
    setManualRowData(manualRowData.filter((item) => item !== id));
  };

  const allData = {
    all: <Checkbox />,
    option: (
      <img
        src={deleteIcon}
        onClick={() => handleDelete(manualRowData.length)}
        className="cursor-pointer"
      />
    ),
    manufacturer: `Mckesson`,
    drugname: "Vaisartan 160 MG Tablet",
    ndc: "672853827",
    packagesize: "100 EA",
    packageprice: "$ 90.27",
    unitprice: "$ 0.9327",
    requiredqty: (
      <div className="qty-count" style={{ width: "107px", height: "40px" }}>
        <div>5</div>
        <div className="d-flex flex-column cursor-pointer">
          <img src={upArrow} />
          <img src={downArrow} />
        </div>
      </div>
    ),
  };

  // const manualRowData = [
  //   {
  //     all: <Checkbox />,
  //     option: (
  //       <img
  //         src={deleteIcon}
  //         onClick={handleDelete}
  //         className="cursor-pointer"
  //       />
  //     ),
  //     manufacturer: "McKesson",
  //     drugname: "Vaisartan 160 MG Tablet",
  //     ndc: "672853827",
  //     packagesize: "100 EA",
  //     packageprice: "$ 90.27",
  //     unitprice: "$ 0.9327",
  //     requiredqty: (
  //       <div className="qty-count" style={{ width: "107px", height: "40px" }}>
  //         {increment}
  //         <div className="d-flex flex-column cursor-pointer">
  //           <img src={upArrow}  />
  //           <img src={downArrow} onClick={() => setIncrement(increment - 1)} />
  //         </div>
  //       </div>
  //     ),
  //   },
  // ];

  return (
    <>
      <div
        className="table-card scroll-table position-relative border-0 rounded bg-white  d-flex flex-column p-3 pt-0"
        style={{ width: "83vw" }}
      >
        <div>
          <div className="head-btns">
            <div className="d-flex gap-2">
              <div>
                <SearchButtons
                  InSize={218}
                  placeHolder={"Search by Drug Name"}
                  data={data}
                  setFilterData={setTableData}
                />
              </div>
              <div>
                <Dropdown isOpen={undefined} toggle={undefined}>
                  <DropdownToggle className="clmn">
                    <img src={columnSelectorIcon} alt="not available" />
                    <span>
                      Columns{" "}
                      {/* {totalCount > 0 && (
                    <div className="totalcount">{totalCount}</div>
                  )} */}
                    </span>
                  </DropdownToggle>
                </Dropdown>
              </div>
              {manualRowData.length > 0 ? (
                <div className="d-flex justify-content-center align-items-center gap-2">
                         <span className="f-16 font-weight-600">Filter</span>
                         <ButtonGroup className="filter-btn-group">
                           <Button
                             color="info"
                             outline
                             onClick={toggleFilter}
                             active={rSelected === "off"}
                           >
                             OFF
                           </Button>
                           <Button
                             color="info"
                             outline
                             active={rSelected === "on"}
                             onClick={toggleFilter}
                           >
                             ON
                           </Button>
                         </ButtonGroup>
                       </div>
              ) : (
                <Button>
                  <img src={filterIcon} /> <span>Filter</span>
                </Button>
              )}
            </div>
            <div className="d-flex">
              <Button className="back-button">
                <img src={catalogIcon} /> Catalog
              </Button>
              <Button disabled>
                <img src={PlusIcon} /> Add Item
              </Button>
            </div>
          </div>
          <ReactStrapTable
            data={rowData}
            columns={headerData}
            greenRow={[1]}
            // enablerowRouting={true}
            // handleRowClick={() => setModalOpen(!modalOpen)}
          />
          {manualRowData.length > 0 ? (
            <>
              <div className="d-flex gap-2" style={{ marginTop: "30px" }}>
                <div>
                  <SearchButtons
                    InSize={200}
                    placeHolder={"Search by Product Name"}
                    data={data}
                    setFilterData={setTableData}
                  />
                </div>
                <div>
                  <Dropdown isOpen={undefined} toggle={undefined}>
                    <DropdownToggle className="clmn">
                      <img src={columnSelectorIcon} alt="not available" />
                      <span className="border-color: #702c62;">
                        Columns{" "}
                        {/* {totalCount > 0 && (
          <div className="totalcount">{totalCount}</div>
        )} */}
                      </span>
                    </DropdownToggle>
                  </Dropdown>
                </div>
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <span className=" font-weight-600">Filter</span>
                  <ButtonGroup className="filter-btn-group">
                    <Button
                      style={{
                        borderBottomLeftRadius: "60px",
                        borderTopLeftRadius: "60px",
                        height: "30px",
                      }}
                      color="info"
                      outline
                      onClick={undefined}
                      active={undefined}
                    >
                      OFF
                    </Button>
                    <Button
                      style={{
                        borderBottomRightRadius: "60px",
                        borderTopRightRadius: "60px",
                        height: "30px",
                      }}
                      color="info"
                      outline
                      onClick={undefined}
                      active={undefined}
                    >
                      ON
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
              <ReactStrapTable data={manualRowData} columns={manualColData} />
            </>
          ) : (
            <div className="manual-data">
              Search by drug name on top section and add it to create a manual
              order.
            </div>
          )}
        </div>

        <div className="create-manual-footer">
          <div>
            <Button
              color="primary"
              className="reset"
              disabled={manualRowData.length > 0 ? false : true}
            >
              Reset
            </Button>
          </div>
          <div className="d-flex">
            <Button
              color="primary"
              className="reset"
              disabled={manualRowData.length > 0 ? false : true}
              onClick={() => toast.success("successfully Submitted")}
            >
              Save
            </Button>
            <Button
              color="primary"
              disabled={manualRowData.length > 0 ? false : true}
            >
              Submit
            </Button>
          </div>
        </div>
        {modalOpen && (
          <div
            onClick={() => setModalOpen(!modalOpen)}
            className="smart-deal-backdrop"
          >
            <SmartDealModal closeButton={() => setModalOpen(false)} />
          </div>
        )}
      </div>
    </>
  );
};

export default CreateManualOrder;
